<div class="blockUIDialog" *ngIf="loading" role="dialog">
    <div class="splash-screen">
        <div class="splash-loader-container">
            <!-- <svg class="splash-loader" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
               <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
            </svg> -->
            <p-progressSpinner strokeWidth="3"></p-progressSpinner>
        </div>
    </div>
</div>

    <router-outlet></router-outlet>
<!-- <div class="navbar navbar-default navbar-fixed-bottom footer-height">
  <div class="container">
      <div class="row" *ngIf="footerMessage.length>0">
          <div class="col-lg-12 col-sm-12">
              <marquee scrollamount=3 behavior="scroll" style="font: 100" direction="left">
                  <strong style="font: bold;color:#337ab7">{{footerMessage}}</strong>
              </marquee>
          </div>
      </div>
      <div class="row">
          <div class="col-lg-3 col-sm-3">
              <button (click)="openPrivacyPolicyPage()" class="btn-link" type="button">
                  <strong style="font:bold;color:#337ab7">
                      <i class=""></i>&nbsp;Privacy Policy
                  </strong>
              </button>
          </div>
          <div class="col-lg-3 col-sm-3">
              <span class="pull-right text-right version-placement">
                  <strong>&copy;
                      <a>&nbsp;Eurofins Scientific {{copyrightYear}}</a>
                  </strong>
              </span>
          </div>
          <div class="col-lg-3 col-sm-3" style="text-align:center">
              <span class="pull-right text-right version-placement">
                  <button (click)="openTermsandConditionPage()" class="btn-link" type="button">
                      <strong style="font:bold;color:#337ab7">
                          <i class=""></i>&nbsp;Terms & Condition
                      </strong>
                  </button>
              </span>
          </div>
          <div class="col-lg-3 col-sm-3">
              <span class="pull-right text-right version-placement">
                  <strong>v{{appVersion}}</strong>
              </span>
          </div>
      </div>
  </div>
</div> -->

<p-dialog header="Terms & Conditions" [style]="{'z-index':'1063'}" [responsive]="true" width="800" [style]="{ 'min-height.px': 500 }"
  [contentStyle]="{ 'min-height.px': 500, 'overflow-y': 'auto' }"
    showEffect="fade" [modal]="true" [closeOnEscape]="false" [closable]="false" position="top" [closable]="true"
    [closeOnEscape]="true" modal="true" showEffect="fade" [(visible)]="display" [draggable]="false" [resizable]="false"
    position="top">
    <div>
        <h1
            style="color: #000000; font-family: 'Segoe UI', 'Helvetica Neue', Helvetica, Arial, Verdana; font-variant-ligatures: normal; font-variant-caps: normal; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; background-color: #ffffff; text-decoration-style: initial; text-decoration-color: initial;">
            <u>
                <span style="font-size: 11pt; font-family: Arial, sans-serif; color: #1f497d;">
                    <b>Information Requirements</b>
                </span>
            </u>
        </h1>
        <p
            style="margin: 0px; line-height: 1.5em; color: #000000; font-family: 'Segoe UI', 'Helvetica Neue', Helvetica, Arial, Verdana; font-size: 12px; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; background-color: #ffffff; text-decoration-style: initial; text-decoration-color: initial;">
            <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">As ECL, we must share certain
                information with our online business customers, including a company name, registration
                details and VAT number if applicable, so we ensure that we legally compliant with the Electronic
                Commerce
                (EC Directive) Regulations 2002.</span>
        </p>
        <p
            style="margin: 0px; line-height: 1.5em; color: #000000; font-family: 'Segoe UI', 'Helvetica Neue', Helvetica, Arial, Verdana; font-size: 12px; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; background-color: #ffffff; text-decoration-style: initial; text-decoration-color: initial;">
            <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">&nbsp;</span>
            <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">&nbsp;</span>
        </p>
        <p
            style="margin: 0in 0in 7.5pt; line-height: 1.5em; color: #000000; font-family: 'Segoe UI', 'Helvetica Neue', Helvetica, Arial, Verdana; font-size: 12px; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration-style: initial; text-decoration-color: initial; background: white;">
            <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">Full company details
                including the following:</span>
        </p>
        <ul>
            <li>
                <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">Name</span>
            </li>
            <li>
                <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">Geographical address (a
                    PO Box address is not acceptable)&nbsp;</span>
            </li>
            <li>
                <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">Email</span>
            </li>
            <li>
                <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">Company registration
                    number&nbsp;</span>
            </li>
            <li>
                <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">Registered address</span>
            </li>
            <li>
                <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">Details of any
                    registration or authorisation schemes to which you belong</span>
            </li>
            <li>
                <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">Details of any
                    professional bodies or trade organisations to which you belong</span>
            </li>
            <li>
                <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">VAT number (if
                    applicable)</span>
            </li>
        </ul>
        <p
            style="margin: 0in 0in 7.5pt; line-height: 1.5em; color: #000000; font-family: 'Segoe UI', 'Helvetica Neue', Helvetica, Arial, Verdana; font-size: 12px; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration-style: initial; text-decoration-color: initial; background: white; box-sizing: border-box;">
            <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">Businesses which are actually
                conducting e-commerce must, additionally, provide the following:</span>
        </p>
        <ul>
            <li>
                <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">Terms and conditions that
                    are readily accessible, fair and meaningful</span>
            </li>
            <li>
                <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">Any relevant codes of
                    practice/conduct and how they can be accessed</span>
            </li>
            <li>
                <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">Technical means by which
                    any input errors can be corrected</span>
            </li>
            <li>
                <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">An outline of the
                    technical steps to follow to conclude a contract</span>
            </li>
            <li>
                <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">An indication of
                    languages offered in which a contract can be concluded</span>
            </li>
            <li>
                <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">Whether a record of the
                    contract is kept by the seller and if this is accessible to the buyer</span>
            </li>
        </ul>
        <p
            style="margin: 0in 0in 7.5pt; line-height: 1.5em; color: #000000; font-family: 'Segoe UI', 'Helvetica Neue', Helvetica, Arial, Verdana; font-size: 12px; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration-style: initial; text-decoration-color: initial; background: white; box-sizing: border-box;">
            <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">Furthermore, any commercial
                communications must clearly: be identifiable as commercial communications;&nbsp;provide
                the terms of any promotional offers;&nbsp;identify on whose behalf the communication is being
                sent.&nbsp;</span>
        </p>
        <h1
            style="color: #000000; font-family: 'Segoe UI', 'Helvetica Neue', Helvetica, Arial, Verdana; font-variant-ligatures: normal; font-variant-caps: normal; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; background-color: #ffffff; text-decoration-style: initial; text-decoration-color: initial;">
            <u>
                <span style="font-size: 11pt; font-family: Arial, sans-serif; color: #1f497d;">
                    <b>Pricing Requirements</b>
                </span>
            </u>
        </h1>
        <p
            style="margin: 0px; line-height: 1.5em; color: #000000; font-family: 'Segoe UI', 'Helvetica Neue', Helvetica, Arial, Verdana; font-size: 12px; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; background-color: #ffffff; text-decoration-style: initial; text-decoration-color: initial; box-sizing: border-box;">
            <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">The Regulations say that any
                prices stipulated on a website should clearly state whether or not they include
                hidden charges such as VAT and delivery. In short, prices should be clear and unambiguous.</span>
        </p>
        <p
            style="margin: 0px; line-height: 1.5em; color: #000000; font-family: 'Segoe UI', 'Helvetica Neue', Helvetica, Arial, Verdana; font-size: 12px; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; background-color: #ffffff; text-decoration-style: initial; text-decoration-color: initial;">
            <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">&nbsp;</span>
        </p>
        <h1
            style="color: #000000; font-family: 'Segoe UI', 'Helvetica Neue', Helvetica, Arial, Verdana; font-variant-ligatures: normal; font-variant-caps: normal; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; background-color: #ffffff; text-decoration-style: initial; text-decoration-color: initial;">
            <u>
                <span style="font-size: 11pt; font-family: Arial, sans-serif; color: #1f497d;">
                    <b>Contract Requirements</b>
                </span>
            </u>
        </h1>
        <p>
            <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">As for the forming of
                electronic contracts, the Regulations state that:</span>
        </p>
        <ul>
            <li>
                <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">Electronic contracts
                    should be able to be completed online</span>
            </li>
            <li>
                <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">The customer has the
                    right and must have the ability to revise any mistakes contained in their order prior
                    to making a purchase (or concluding the contract)</span>
            </li>
            <li>
                <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">Once the order is placed,
                    confirmation of the order and all relevant information, including&nbsp;
                    <a style="color: #007acc;" href="https://www.rocketlawyer.co.uk/documents/terms-and-conditions.rl">
                        <span style="color: #1f497d;">Terms and conditions</span>
                    </a>, delivery times and prices should be sent to the customer without undue delay</span>
            </li>
            <li>
                <span style="font-size: 10pt; font-family: Arial, sans-serif; color: #1f497d;">Online businesses are
                    also obliged to provide customers with all of the steps involved in the ordering process,
                    together with information relating to their contract, eg whether or not the business will file the
                    electronic
                    contract and whether it is readily accessible. Online businesses must inform customers of any codes
                    of
                    conduct they adhere to, as well as advice on how customers can consult them</span>
            </li>
        </ul>
    </div>
    <p-footer>
        <div style="float:right">
            <button type="button" class="btn btn-primary" (click)="closeDialog()">
                <i class="fa fa-close"></i>&nbsp;Close</button>
        </div>
    </p-footer>
</p-dialog>